/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubordinateIds
 */
export interface SubordinateIds {
    /**
     * The ids of all direct and indirect subordinates of the current employee
     * @type {Array<number>}
     * @memberof SubordinateIds
     */
    employeeIds: Array<number>;
}

/**
 * Check if a given object implements the SubordinateIds interface.
 */
export function instanceOfSubordinateIds(value: object): value is SubordinateIds {
    if (!('employeeIds' in value) || value['employeeIds'] === undefined) return false;
    return true;
}

export function SubordinateIdsFromJSON(json: any): SubordinateIds {
    return SubordinateIdsFromJSONTyped(json, false);
}

export function SubordinateIdsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubordinateIds {
    if (json == null) {
        return json;
    }
    return {
        
        'employeeIds': json['employeeIds'],
    };
}

  export function SubordinateIdsToJSON(json: any): SubordinateIds {
      return SubordinateIdsToJSONTyped(json, false);
  }

  export function SubordinateIdsToJSONTyped(value?: SubordinateIds | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employeeIds': value['employeeIds'],
    };
}

